/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
Component: CoachingPage.tsx
*/

import { PageSection, Column, Row, Content, Title } from './CoachingPage.css';
import { FooterSection } from '../Home/HomePage.css';
import colors from '../../../styles/colors';
import Footer from '../Home/Footer';
import React from 'react';
import { useRecoilState } from 'recoil';
import { userState } from '../../../recoil/atoms/userAtoms';

export const CoachingPage = () => {
  const [user] = useRecoilState(userState);
  const createMarkup1 = () => {
    return {
      __html: '<p>My strategy is 100% results-oriented.  If you want to sample how I work 1-on-1, let’s schedule a one-time deep dive consultation.<p />' +
        '<p />' +
        'For one hour we’ll explore your technology objectives that are frustrating, confusing, or painful. Together we’ll get clarity and uncover those hidden patterns or missing knowledge that might be keeping what you want at bay. <p />' +
        '<p />' +
        'We’ll also map your technology objectives, then create a custom-built plan to transcend the major elements that are needed from having the success you deserve.<p />' +
        '<p />' +
        'This will be a laser-focused coaching session dedicated to cultivating a  new mindset, new beliefs, and new day-to-day actions that will produce immediate results in your life.<p />' +
        '<p />' +
        '<b>✅&nbsp One-time tutor session $199 / hr</b>' +
        '<br /><br />Are you looking for a programming tutor in react, javascript, typescript, mongodb, nestjs, web3, node or d3?' +
        '<br/><br />I' +
        ' will tutor ' +
        'You will be provided with ebook and/or other learning materials for yours to keep, or just help you code your problem away.' +
        ' Session(s). Can be done over Slack, Discord, Zoom, or Microsoft Teams.<br /><br />' +
        '<b>✅&nbsp One-time tutor session $199 / hr</b><br/>' +
        '<b>✅&nbsp On-going sessions $125 / hr</b><br/>' +
        '<b>✅&nbsp 1-Day Package Cost: $999<br />' +
        '✅&nbsp 1-Week Package Cost: $4,497<br />' +
        '✅&nbsp 1-Month Package Cost: $19,980</b>' +
        '<br /><br />To book <u><a href="mailto:eladny+inquiries@gmail.com">contact</a></u> me directly.',
    };
  };
  return (
    <>
      <PageSection
        isLightsOn={user.isLightsOn}
        colorDay={colors.white}
        colorNight={colors.lightGrey}
      >
        <Column>
          <Row>
            <Title>Coaching</Title>
          </Row>
          <Row>
            <Content dangerouslySetInnerHTML={createMarkup1()} />
          </Row>
        </Column>
      </PageSection>
      <FooterSection isLightsOn={user.isLightsOn} colorDay={colors.white} colorNight={colors.white}>
        <Footer
          isLightsOn={user.isLightsOn}
          colorDay={colors.cloudGrey}
          colorNight={colors.white}
        />
      </FooterSection>
    </>
  );
};

export default CoachingPage;
